import React from "react";
import {BrowserRouter as Router, Route, Routes} from "react-router-dom";
import ProtectedRoute from "./Components/Layouts/ProtectedRoute";
import Login from "./Components/Login/Login";
import Navbar from "./Components/Layouts/Navbar";
import PreReservationTable from "./Components/Pre-reservation/Pre-reservation";
import PreReservationDetail from "./Components/Pre-reservation/Pre-reservationDetail";
import AddPreReservation from "./Components/Pre-reservation/AddPreReservation";
import ReservationTable from "./Components/Reservation/ReservationTable";
import ReservationDetail from "./Components/Reservation/ReservationDetail";
import EditReservation from "./Components/Reservation/EditReservation";
import RecapReservation from "./Components/Reservation/RecapReservation";
import NavetteTable from "./Components/Navette/NavetteTable";
import DetailsNavette from "./Components/Navette/DetailsNavette";
import UtilisateursTable from "./Components/utilisateurs/utilisateursTable";
import ModifierUtilisateurs from "./Components/utilisateurs/ModifierUtilisateurs";
import UtilisateursDetails from "./Components/utilisateurs/utilisateursDetails";
import ImportUtilisateurs from "./Components/utilisateurs/ImporterUtilisateur";
import Rapports from "./Components/Repporting/Rapports";
import SocieteTable from "./Components/Societe/SocieteTable";
import SiteTable from "./Components/Sites/SiteTable";
import VehiculeTable from "./Components/Vehicules/VehiculeTable";
import DetailsVehicules from "./Components/Vehicules/DetailsVehicules";
import TrajeTable from "./Components/Trajets/TrajetsTable";
import DetailTrajets from "./Components/Trajets/DetailTrajet";
import TarifsTable from "./Components/Tarifs/TarifTAble";
import AddTarif from "./Components/Tarifs/AddTarif";
import EditTarif from "./Components/Tarifs/edit-tarif";
import PickupTable from "./Components/PickUp/PickupTable";
import ShiftTable from "./Components/Shifts/ShiftTable";
import EmailTable from "./Components/Emails/EmailTable";
import MonCompte from "./Components/PersonalInfo/MonCompte";
import FirstLogin from "./Components/PersonalInfo/FirstLogin";
import AdminCompte from "./Components/PersonalInfo/AdminCompte";

function App() {
  return (
    <Routes>
      <Route path="/" element={
        <ProtectedRoute requireAuth={false}>
          <Login />
        </ProtectedRoute>
      } />
      <Route path="/navbar" element={
        <ProtectedRoute>
          <Navbar />
        </ProtectedRoute>
      } />
      
      {/* Pre-reservation routes - Only for Users (ID_Role = 2) */}
      <Route path="/pre-reservation" element={
        <ProtectedRoute allowedRoles={[2]}>
          <PreReservationTable />
        </ProtectedRoute>
      } />
      <Route path="/pre-reservation-detail" element={
        <ProtectedRoute allowedRoles={[2]}>
          <PreReservationDetail />
        </ProtectedRoute>
      } />
      <Route path="/add-pre-reservation" element={
        <ProtectedRoute allowedRoles={[2]}>
          <AddPreReservation />
        </ProtectedRoute>
      } />
      
      {/* Reservation routes - For Users (ID_Role = 2) */}
      <Route path="/reservation" element={
        <ProtectedRoute allowedRoles={[1,2]}>
          <ReservationTable />
        </ProtectedRoute>
      } />
      <Route path="/reservation-detail" element={
        <ProtectedRoute allowedRoles={[1,2]}>
          <ReservationDetail />
        </ProtectedRoute>
      } />
      <Route path="/edit-reservation" element={
        <ProtectedRoute allowedRoles={[1,2]}>
          <EditReservation />
        </ProtectedRoute>
      } />
      <Route path="/recap-reservation" element={
        <ProtectedRoute allowedRoles={[1]}>
          <RecapReservation />
        </ProtectedRoute>
      } />
      
      {/* Admin-only routes (ID_Role = 1) */}
      <Route path="/navette" element={
        <ProtectedRoute allowedRoles={[1]}>
          <NavetteTable />
        </ProtectedRoute>
      } />
      <Route path="/navette-detail" element={
        <ProtectedRoute allowedRoles={[1]}>
          <DetailsNavette />
        </ProtectedRoute>
      } />
      <Route path="/utilisateurs" element={
        <ProtectedRoute allowedRoles={[1]}>
          <UtilisateursTable />
        </ProtectedRoute>
      } />
      <Route path="/modifier-utilisateurs/:userId" element={
        <ProtectedRoute allowedRoles={[1]}>
          <ModifierUtilisateurs />
        </ProtectedRoute>
      } />
      <Route path="/utilisateurs-details/:userId" element={
        <ProtectedRoute allowedRoles={[1]}>
          <UtilisateursDetails />
        </ProtectedRoute>
      } />
      <Route path="/import-utilisateurs" element={
        <ProtectedRoute allowedRoles={[1]}>
          <ImportUtilisateurs />
        </ProtectedRoute>
      } />
      <Route path="/reporting" element={
        <ProtectedRoute allowedRoles={[1]}>
          <Rapports />
        </ProtectedRoute>
      } />
      <Route path="/societe" element={
        <ProtectedRoute allowedRoles={[1]}>
          <SocieteTable />
        </ProtectedRoute>
      } />
      <Route path="/site" element={
        <ProtectedRoute allowedRoles={[1]}>
          <SiteTable />
        </ProtectedRoute>
      } />
      <Route path="/vehicule" element={
        <ProtectedRoute allowedRoles={[1]}>
          <VehiculeTable />
        </ProtectedRoute>
      } />
      <Route path="/details-vehicules/:vehicleId" element={
        <ProtectedRoute allowedRoles={[1]}>
          <DetailsVehicules />
        </ProtectedRoute>
      } />
      <Route path="/trajets" element={
        <ProtectedRoute allowedRoles={[1]}>
          <TrajeTable />
        </ProtectedRoute>
      } />
      <Route path="/detail-trajets" element={
        <ProtectedRoute allowedRoles={[1]}>
          <DetailTrajets />
        </ProtectedRoute>
      } />
      <Route path="/tarifs" element={
        <ProtectedRoute allowedRoles={[1]}>
          <TarifsTable />
        </ProtectedRoute>
      } />
      <Route path="/Add-tarif" element={
        <ProtectedRoute allowedRoles={[1]}>
          <AddTarif/>
        </ProtectedRoute>
      }/>
      <Route path="/edit-tarif" element={
        <ProtectedRoute allowedRoles={[1]}>
          <EditTarif/>
        </ProtectedRoute>
      }/>
      <Route path="/Pickup" element={
        <ProtectedRoute allowedRoles={[1]}>
          <PickupTable/>
        </ProtectedRoute>
      }/>
      <Route path="/Shifts" element={
        <ProtectedRoute allowedRoles={[1]}>
          <ShiftTable/>
        </ProtectedRoute>
      }/>
      <Route path="/Emails" element={
        <ProtectedRoute allowedRoles={[1]}>
          <EmailTable/>
        </ProtectedRoute>
      }/>
      
      {/* Account routes - Available for both roles */}
      <Route path="/MonCompte" element={
        <ProtectedRoute allowedRoles={[1, 2]}>
          <MonCompte/>
        </ProtectedRoute>
      }/>
      <Route path="/FirstLogin" element={
        <ProtectedRoute>
          <FirstLogin/>
        </ProtectedRoute>
      }/>
      <Route path="/AdminCompte" element={
        <ProtectedRoute allowedRoles={[1]}>
          <AdminCompte/>
        </ProtectedRoute>
      }/>
    </Routes>
  );
}

export default App;

